import InterstateChampionshipImage from '../Images/InterstateChampionship.jpg';

export const clubStats = [
  { id: 1, value: "16+", label: "First Team Players" },
  { id: 2, value: "2", label: "Weekly Training Sessions" },
  { id: 3, value: "2012", label: "Club Founded" },
  { id: 4, value: "20+", label: "Community Events Participant" }
];

export const latestNews = [
  {
    id: 1,
    title: "Thunder Dragon FC Announces as the host of the 13th Bhutanese Interstate Soccer Championship 2026",
    date: "2026-06-26",
    summary:
      "We're excited to welcome teams, supporters, volunteers, and the entire Bhutanese community for one incredible weekend. See you in Melbourne!",
    image: InterstateChampionshipImage,
    imageAlt: "13th Bhutanese Interstate Soccer Championship 2026"
  },
  {
    id: 2,
    title: "Thunder Dragon FC Opens Membership Registrations",
    date: "2026-03-17",
    summary:
      "Membership registrations are now open for new and returning members."
  },
  {
    id: 3,
    title: "2025 Season Recognized at Awards Ceremony",
    date: "2025-11-10",
    summary:
      "We celebrated the players, volunteers, sponsors, and supporters whose ongoing work continues to strengthen the Thunder Dragon FC family."
  }
];

export const leagueTable = [
  { pos: 1, team: "Dandy Strikers", played: 10, points: 28, gd: 28 },
  { pos: 2, team: "Craigieburn Brigade", played: 10, points: 25, gd: 25 },
  { pos: 3, team: "Mars FC", played: 10, points: 22, gd: 17 },
  { pos: 4, team: "Kabul Stars FC", played: 10, points: 21, gd: 14 },
  { pos: 5, team: "MTU CROCS", played: 10, points: 18, gd: 8 },
  { pos: 6, team: "Himalayan FC", played: 10, points: 16, gd: 11 },
  { pos: 7, team: "Royale FC", played: 10, points: 11, gd: -5 },
  { pos: 8, team: "Thunder Dragon FC", played: 10, points: 8, gd: -25 },
  { pos: 9, team: "West Melbourne FC", played: 10, points: 6, gd: -21 },
  { pos: 10, team: "Ghan United", played: 8, points: 3, gd: -20 },
  { pos: 11, team: "Umoja Stars", played: 10, points: 1, gd: -26 }
];

